// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"152":"base","583":"licenses","667":"invoices","779":"error"}[chunkId] + "." + {"152":"814140cf","583":"1f964369","667":"0c489090","779":"74e2b177"}[chunkId] + ".css";
};